"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberingListStyle = void 0;
var tslib_1 = require("tslib");
var style_base_1 = require("../style-base");
var NumberingListStyle = (function (_super) {
    tslib_1.__extends(NumberingListStyle, _super);
    function NumberingListStyle(styleName, localizedName, deleted, hidden, semihidden, isDefault, numberingListIndex, id) {
        var _this = _super.call(this, styleName, localizedName, deleted, hidden, semihidden, isDefault, id) || this;
        _this.numberingListIndex = numberingListIndex;
        return _this;
    }
    NumberingListStyle.prototype.clone = function () {
        return new NumberingListStyle(this.styleName, this.localizedName, this.deleted, this.hidden, this.semihidden, this.isDefault, this.numberingListIndex, this.id);
    };
    return NumberingListStyle;
}(style_base_1.StyleBase));
exports.NumberingListStyle = NumberingListStyle;
